<template>
  <div>
    <b-modal
      id="addcard-modal"
      style="justify-content: space-around"
      hide-footer
      :title="cardModalTitle"
      @hide="hideAddCardModal"
    >
      <b-alert :show="error.length > 0" variant="danger">
        <p v-for="er in error" v-bind:key="er">{{ er }}</p>
      </b-alert>
      <b-form>
        <b-row>
          <b-col>
            <b-form-group
              id="input_card_iban_1"
              label="شماره شبا:"
              label-for="input_card_iban"
            >
              <b-input-group size="lg" append="IR">
                <b-input
                  @paste.prevent="pasteIBAN"
                  @change="findBank"
                  style="word-spacing: 8px"
                  maxlength="30"
                  class="text-right ltr"
                  id="input_card_iban"
                  v-model="ibanNumber"
                  placeholder="-- ---- ---- ---- ---- ---- --"
                  v-mask="'## #### #### #### #### #### #### ##'"
                  required
                ></b-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="bank_id"
              label="بانک:"
              label-for="select_bank_name"
            >
              <MDDropdown
                id="select_bank_name"
                v-model="cardBankName"
                aria-placeholder="نام بانک"
                group="13"
                @input="onChange($event)"
                tip-text="انتخاب بانک"
              ></MDDropdown>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col>
            <b-form-select
              :options="businessPartnersOptions"
              v-model="is_business_partners"
            >
            </b-form-select>
          </b-col>
        </b-row>
        <b-row v-if="is_business_partners == 0">
          <b-col>
            <b-form-group id="bank_id" label label-for="isDefault">
              <b-form-checkbox
                class="switch-lg"
                switch
                v-model="is_default"
                size="lg"
                >حساب پیش فرض</b-form-checkbox
              >
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="bank_id" label label-for="isDefault">
              <b-form-checkbox switch v-model="is_enable" size="lg"
                >فعال</b-form-checkbox
              >
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col>
            <b-form-group id="bank_id" label="شماره کارت:" label-for="select_bank_name">
              <b-input id="input_card_iban" v-model="card_number" placeholder="شماره کارت"></b-input>
            </b-form-group>
          </b-col>
        </b-row>-->
        <b-row class="mt-3">
          <b-col>
            <b-button
              style="width: 100%"
              variant="danger"
              @click="hideAddCardModal"
              >بازگشت</b-button
            >
          </b-col>
          <b-col>
            <b-button
              style="width: 100%"
              variant="primary"
              id="btnSave"
              :class="loading ? 'spinner spinner-light spinner-right' : ''"
              @click="sendAddOrEditCardRequest"
              >ذخیره</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>
<style>
.ltr {
  direction: ltr;
}
.spinner.spinner-right {
  padding-left: 3.5rem !important;
}
</style>
<script>
import MDDropdown from "../../components/MDDropdown";
import httpHelper from "../../helpers/httpHelper";
import persianDate from "../../helpers/persianDate";

export default {
  name: "addCard",
  components: { MDDropdown },
  props: ["afterdone", "cardId", "canceled", "justShoraka"],
  data: function () {
    return {
      loading: false,
      businessPartnersOptions: [
        {
          text: "حساب شخصی",
          value: 0,
        },
        {
          text: "حساب شرکای تجاری",
          value: 1,
        },
      ],

      is_business_partners: 0,
      show_sheba: false,
      error: [],
      cardList: [],
      cardModalTitle: "افزودن حساب بانکی",
      cardAliasName: null,
      cardBankName: null,
      card_number: null,
      accountNumber: null,
      ibanNumber: null,
      cardExpireYear: null,
      cardExpireMonth: null,
      isInEditMode: false,
      is_default: true,
      is_enable: true,
    };
  },
  watch: {
    cardId: function (newVal, oldVal) {
      if (newVal != null) {
        this.cardModalTitle = "ویرایش حساب بانکی";
        httpHelper.getData("usercards?id=" + newVal).then((res) => {
          if (res.success) {
            this.ibanNumber = res.result.shaba_number;
            this.cardBankName = res.result.bank_name.id;
            this.is_default = res.result.is_default == 1;
            this.is_enable = res.result.is_enable == 1;
          }
        });
      } else {
        this.cardModalTitle = "افزودن حساب بانکی";
      }
    },
    ibanNumber: function (newVal, oldVal) {
      if (!newVal) {
        return;
      }
      this.ibanNumber = newVal.toEnDigits();
      if (newVal.split(" ")[1]) {
        if (newVal.split(" ")[1].startsWith("055")) {
          this.cardBankName = 516;
        } else if (newVal.split(" ")[1].startsWith("054")) {
          this.cardBankName = 518;
        } else if (newVal.split(" ")[1].startsWith("057")) {
          this.cardBankName = 519;
        } else if (newVal.split(" ")[1].startsWith("021")) {
          this.cardBankName = 544;
        } else if (newVal.split(" ")[1].startsWith("018")) {
          this.cardBankName = 521;
        } else if (newVal.split(" ")[1].startsWith("051")) {
          this.cardBankName = 545;
        } else if (newVal.split(" ")[1].startsWith("019")) {
          this.cardBankName = 532;
        } else if (newVal.split(" ")[1].startsWith("013")) {
          this.cardBankName = 526;
        } else if (newVal.split(" ")[1].startsWith("056")) {
          if (newVal.split(" ")[2].startsWith("6118")) {
            this.cardBankName = 2069;
          }
          else{
            this.cardBankName = 527;
          }
        } else if (newVal.split(" ")[1].startsWith("015")) {
          this.cardBankName = 528;
        } else if (newVal.split(" ")[1].startsWith("058")) {
          this.cardBankName = 529;
        } else if (newVal.split(" ")[1].startsWith("011")) {
          this.cardBankName = 533;
        } else if (newVal.split(" ")[1].startsWith("053")) {
          this.cardBankName = 536;
        } else if (newVal.split(" ")[1].startsWith("016")) {
          this.cardBankName = 537;
        } else if (newVal.split(" ")[1].startsWith("010")) {
          this.cardBankName = 539;
        } else if (newVal.split(" ")[1].startsWith("014")) {
          this.cardBankName = 540;
        } else if (newVal.split(" ")[1].startsWith("012")) {
          this.cardBankName = 541;
        } else if (newVal.split(" ")[1].startsWith("017")) {
          this.cardBankName = 542;
        } else if (newVal.split(" ")[1].startsWith("070")) {
          this.cardBankName = 1703;
        } else if (newVal.split(" ")[1].startsWith("063")) {
          this.cardBankName = 1711;
        } else if (newVal.split(" ")[1].startsWith("061")) {
          this.cardBankName = 531;
        } else if (newVal.split(" ")[1].startsWith("052")) {
          this.cardBankName = 535;
        } else if (newVal.split(" ")[1].startsWith("069")) {
          this.cardBankName = 517;
        } else if (newVal.split(" ")[1].startsWith("062")) {
          this.cardBankName = 520;
        } else if (newVal.split(" ")[1].startsWith("022")) {
          this.cardBankName = 522;
        } else if (newVal.split(" ")[1].startsWith("065")) {
          this.cardBankName = 524;
        } else if (newVal.split(" ")[1].startsWith("066")) {
          this.cardBankName = 525;
        } else if (newVal.split(" ")[1].startsWith("059")) {
          this.cardBankName = 530;
        } else if (newVal.split(" ")[1].startsWith("060")) {
          this.cardBankName = 534;
        } else if (newVal.split(" ")[1].startsWith("064")) {
          this.cardBankName = 538;
        } else if (newVal.split(" ")[1].startsWith("079")) {
          this.cardBankName = 543;
        } else if (newVal.split(" ")[1].startsWith("073")) {
          this.cardBankName = 546;
        } else if (newVal.split(" ")[1].startsWith("020")) {
          this.cardBankName = 523;
        } else if (newVal.split(" ")[1].startsWith("078")) {
          this.cardBankName = 1713;
        } else if (newVal.split(" ")[1].startsWith("095")) {
          this.cardBankName = 1714;
        } else if (newVal.split(" ")[1].startsWith("075")) {
          this.cardBankName = 1715;
        } else if (newVal.split(" ")[1].startsWith("080")) {
          this.cardBankName = 1716;
        } else {
          this.cardBankName = null;
        }
      } else {
        this.cardBankName = null;
      }
    },
  },
  methods: {
    pasteIBAN(event) {
      this.ibanNumber = (
        "IR" + event.clipboardData.getData("text").split(" ").join("")
      )
        .match(/.{1,4}/g)
        .join(" ")
        .replace("IR", "");
    },
    findBank(event) {
    },
    shepaCeprator(event) {
      var remspace = this.ibanNumber.split(" ");
      if (remspace != null) {
        remspace = remspace.join("");
      } else {
        remspace = this.ibanNumbe;
      }
      var str = remspace;
      if (str == null) {
      } else {
        this.ibanNumber = str.match(/.{1,4}/g).join(" ");
      }
      //this.ibanNumber = "IR " + str.match(/.{4}|.{1,2}/g).join(' ');
    },
    onChange(event) {
    },
    showAddNewCard: function () {
      this.isInEditMode = false;
      this.ibanNumber = "";
      this.cardBankName = null;
      this.showCardModal();
    },
    hideAddCardModal: function () {
      this.ibanNumber = null;
      this.cardBankName = null;
      this.error = [];
      if (this.canceled != null) {
        this.canceled();
      }
      this.$bvModal.hide("addcard-modal");
    },
    sendAddOrEditCardRequest: function () {
      if (this.loading) {
        return;
      }
      this.loading = true;
      // this.$refs["btnSave"].classList.add(
      //   "spinner",
      //   "spinner-light",
      //   "spinner-right"
      // );
      httpHelper.setAuth();
      let cardData = {
        nickname: this.cardAliasName,
        card_number: this.card_number,
        shaba_number: "IR" + this.ibanNumber.split(" ").join(""),
        expire_month: this.cardExpireMonth,
        expire_year: this.cardExpireYear,
        mdid13_bank_name: this.cardBankName,
        account_number: this.accountNumber,
        is_enable: this.is_business_partners == 0 ? this.is_enable : true,
        is_default: this.is_business_partners == 0 ? this.is_default : false,
        is_business_partners: this.is_business_partners,
      };
      if (this.cardId != null) {
        cardData.id = this.cardId;
      }

      httpHelper
        .postData("usercards", cardData)
        .then((response) => {
          this.loading = false;
          if (response.success === true) {
            // this.$refs["btnSave"].classList.remove(
            //   "spinner",
            //   "spinner-light",
            //   "spinner-right"
            // );
            this.afterdone(response.result);

            this.$bvModal.hide("addcard-modal");

            this.hideAddCardModal();
          } else {
            this.error = [];
            if (response.errorCode == 201) {
              this.show_sheba = true;
            }
            for (var key in response.error) {
              response.error[key].forEach((element) => {
                this.error.push(element);
              });
            }
          }
        })
        .catch((res) => {
        });
    },
    editBankingCard: function (card) {
      this.isInEditMode = true;
      httpHelper
        .getData("usercards?id=" + card.id)
        .then((response) => {
          if (response.success == true) {
            let bankingCardInfo = response.result[0];
            //this.cardId = bankingCardInfo.id;
            this.cardAliasName = bankingCardInfo.nickname;
            this.card_number = bankingCardInfo.card_number;
            this.ibanNumber = bankingCardInfo.shaba_number;
            this.cardExpireMonth = bankingCardInfo.expire_month;
            this.cardExpireYear = bankingCardInfo.expire_year;
            this.cardBankName = bankingCardInfo.mdid13_bank_name;
            this.accountNumber = bankingCardInfo.account_number;
            this.showCardModal();
          }
        })
        .finally(() => {});
    },
  },
  mounted() {
    if (this.justShoraka === "partners") {
      this.is_business_partners = 1;
      delete this.businessPartnersOptions[0];
    } else if (this.justShoraka === "personal") {
      this.is_business_partners = 0;
      delete this.businessPartnersOptions[1];
    } else {
      this.is_business_partners = 0;
    }
  },
};
</script>